import { SidebarProvider } from "@telluscompany/design-system";
import { AppBackground } from "../../atoms";

interface MainTemplateProps {
  children?: React.ReactNode;
  Header?: React.ReactNode;
  SideBar?: React.ReactNode;
}

const getCookieSidebarState = () => {
  const match = document.cookie
    .split("; ")
    .find((row) => row.startsWith("sidebar_state="));
  return match ? match.split("=")[1] === "true" : true; // true é o fallback
};

const MainTemplate: React.FC<MainTemplateProps> = ({
  children,
  Header,
  SideBar,
}) => {
  return (
    <AppBackground className="h-screen flex flex-col overflow-hidden">
      {Header}
      <div className="flex flex-1 overflow-hidden">
        <SidebarProvider defaultOpen={getCookieSidebarState()}>
          {SideBar}
          <main className="flex-1 w-full overflow-y-auto">{children}</main>
        </SidebarProvider>
      </div>
    </AppBackground>
  );
};

export { MainTemplate };
